module.exports = __webpack_public_path__ + "img/notebook.a938998c.png";